import { render } from "./AdminInvitations.vue?vue&type=template&id=d573d768&scoped=true"
import script from "./AdminInvitations.vue?vue&type=script&lang=js"
export * from "./AdminInvitations.vue?vue&type=script&lang=js"

import "./AdminInvitations.vue?vue&type=style&index=0&id=d573d768&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d573d768"]])

export default __exports__